import Edit_meta from '../page/Edit_meta.js'
import List_meta from '../page/List_meta.js'
import default_attribute from './StateDefaultAttribute.js'

const state = {
  type: 'contact',
  loaded: {
    orgs: false,
    attributes: false,
    services: false,
    groups: false,
  },
  contact: {
    pagination: true,
    loaded: false,
    headers: [],
    headers_index: [],
    data: [],
    items: [],
    items_index: {},
    selected: [],
    all_selected: false,
    searchs: [],
    actions: [],
    list_req: {
      sel: [],
      sort: [],
      searchs: [],
      page: 1,
      type: 1,
      seeAll: false,
      is_report: false,
    },
    tot: 0,
    pageCount: 0,
    current_sort: null,
    sort: null,
    action_modal_state: false,
    action_req: {
      mode: '',
      actions: []
    },
    export_modal_state: false,
    export_mode: '',
    univers_modal_state: false,
    univers_single_modal_state: false,
    univers_single_action: '',
    univers_mode: '',
    univers_action: '',
    merge_modal_state: false,
    merge_main_id: null,
    merge_items: [],
  },
  organisation: {
    pagination: true,
    loaded: false,
    headers: [],
    headers_index: [],
    data: [],
    items: [],
    items_index: {},
    selected: [],
    all_selected: false,
    searchs: [
    ],
    actions: [
    ],
    list_req: {
      sel: [],
      sort: [],
      searchs: [],
      page: 1,
      type: 2,
      seeAll: false,
      is_report: false,
    },
    tot: 0,
    pageCount: 0,
    current_sort: null,
    sort: null,
    action_modal_state: false,
    action_req: {
      mode: '',
      actions: []
    },
    export_modal_state: false,
    export_mode: '',
    univers_modal_state: false,
    univers_single_modal_state: false,
    univers_single_action: '',
    univers_mode: '',
    univers_action: '',
    merge_modal_state: false,
    merge_main_id: null,
    merge_items: [],
  },
  contact_externe: {
    pagination: true,
    loaded: false,
    headers: [],
    headers_index: [],
    data: [],
    items: [],
    items_index: {},
    selected: [],
    all_selected: false,
    searchs: [
    ],
    actions: [
    ],
    list_req: {
      sel: [],
      sort: [],
      searchs: [],
      page: 1,
      type: 3,
      seeAll: false,
      is_report: false,
    },
    tot: 0,
    pageCount: 0,
    current_sort: null,
    sort: null,
    action_modal_state: false,
    action_req: {
      mode: '',
      actions: []
    },
    export_modal_state: false,
    export_mode: '',
    univers_modal_state: false,
    univers_single_modal_state: false,
    univers_single_action: '',
    univers_mode: '',
    univers_action: '',
    merge_modal_state: false,
    merge_main_id: null,
    merge_items: [],
  },
  organisation_externe: {
    pagination: true,
    loaded: false,
    headers: [],
    headers_index: [],
    data: [],
    items: [],
    items_index: {},
    selected: [],
    all_selected: false,
    searchs: [
    ],
    actions: [
    ],
    list_req: {
      sel: [],
      sort: [],
      searchs: [],
      page: 1,
      type: 4,
      seeAll: false,
      is_report: false,
    },
    tot: 0,
    pageCount: 0,
    current_sort: null,
    sort: null,
    action_modal_state: false,
    action_req: {
      mode: '',
      actions: []
    },
    export_modal_state: false,
    export_mode: '',
    univers_modal_state: false,
    univers_single_modal_state: false,
    univers_single_action: '',
    univers_mode: '',
    univers_action: '',
    merge_modal_state: false,
    merge_main_id: null,
    merge_items: [],
  },
  services: {},
  contactEdit: Edit_meta.full_blank_state(1),
  attributes: {
    '1': default_attribute(), // email
    '2': default_attribute(), // phone
    '3': default_attribute(), // address
    '5': default_attribute(), // organization
    '6': default_attribute(), // group
    '7': default_attribute(), // Association
    '8': default_attribute(), // Organisme public
    '9': default_attribute(), // Entreprise
    '10': default_attribute(), // Media
    '62': default_attribute(), // contact
    '2289': default_attribute() // contact
  // 25  1 Libellé 0 1 0 0 0
  // 26  2 Libellé
  // 55  3 Libellé
  // 11  7 Rôle  1 1 0 0 0
  // 22  8 Rôle  1 1 0 0 0
  // 58  9 Rôle
  },
  accounts: [],
  auth_page_url: '',
  token: '',
  univers: 0,
  rights: 0,
  logged: false,
  orgs_index: {
    list: [],
    ref: {},
    index: {},
    types: {}
  },
  groups_index: {
    list: [],
    ref: {},
    index: {},
    types: {}
  },
}

export default state
